export enum OrderColumns {
  PurchaseOrderNo = 'qp+t',
  OrderDate = '7aP1',
  ExternalRefNo = 'r3uu',
  ExternalReferenceNumber = 'vEjM',
  InvoiceNo = '8i3z',
  InvoiceNumber = 'wHyc',
}

export enum OrderForm {
  OrderSummary = 'Rrtm',
  deliveryDate = 'delivery date',
  orderDate = 'order date',
  SaveInventoryOrderForm = 'SB/b',
  CancelInventoryOrder = 'd0q7',
}
